<template>
  <v-app>
    <CsjpNavbar/>
    <v-main>
      <router-view/> 
    </v-main>
    <CsjpFooter/>

  </v-app>
</template>

<script>

  const CsjpNavbar = () => import('@/components/Navbar.vue')
  const CsjpFooter = () => import('@/components/Footer.vue')

export default {
  name: 'App',

  components: {
    CsjpNavbar,
    CsjpFooter
  },

  data: () => ({
    //
  }),
};
</script>
